import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useOccurenceLocationChartsDataContext } from './hooks/useOccurenceLocationChartsDataContext';

export const OcurrenceNeighborhood = () => {
    const { chartData } = useOccurenceLocationChartsDataContext();


    return (
        <SimpleBars
            title={'Bairro de Ocorrência (Top 5)'}
            horizontal={true}
            subtitles={chartData?.ocurrenceNeighborhood?.map((item) => item.description)}
            values={chartData?.ocurrenceNeighborhood?.map((item) => item.total  ||  0)}
            className='aligned-container'
        />
    );
};
